<template>
  <nav>
    <ol class="breadcrumbs">
      <a href="https://uranaifes.com/">トップ</a>
      <span>></span>
      <a href="https://uranai.tv/">ストア</a>
      <span v-if="categoryActive">></span>
      <a href="">{{ category }}</a>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'bread-crumb',
  props: {
    lowest: {
      type: String,
      default: null
    }
  },
  computed: {
    category() {
      if (this.lowest === 'ordermade') {
        return 'オーダーメイド型占い'
      } else {
        return this.lowest
      }
    },
    categoryActive() {
      if (this.lowest == null) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumbs {
  font-size: 10px;
  color: #9b9b9b;
  display: flex;
  flex-direction: row;
  list-style: none;
  padding: 12px;
  margin: 0;
  background: #f3f3f3;
  box-shadow: 0px 1px 0px #EDEDED, inset 0px 1px 0px #EDEDED;
  & > a {
    color: #9b9b9b;
    text-decoration: none;
    &:first-child {
      margin-right: 8px;
    }
    &:nth-child(1n+2) {
      margin: 0 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/BreadCrumb.vue